export default "__VITE_ASSET__BEqRYpUU__"